import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from '../../AxiosConfig'
import config from '../../config'
import jwt_decode from 'jwt-decode'

export const requestOtp = createAsyncThunk(
  'auth/requestOtp',
  async (params) => {
    const { mobileNumber } = params
    const response = await axios.post(config.apiUrl + '/user/login', { "MobileNo": mobileNumber })
    const { data } = response
    return data
  }
)

export const validateOtp = createAsyncThunk(
  'auth/validateOtp',
  async (params) => {
    const { mobileNumber, otp } = params
    const response = await axios.post(config.apiUrl + '/user/login', { "MobileNo": mobileNumber, "otp": otp })
    console.log(response)
    const { data } = response
    return data
  }
)

const initialState = {
  authToken: null,
  ID: null,
  Name: null,
  hideSendOtpButton: false,
  showVerifyOtpForm: false,
  showLoginForm: true,
  otpRequestSuccess: false,
  otpRequestError: false,
  otpValidateSuccess: false,
  otpValidateError: false,
  role: null,
  RoleID: null,
  userAccess: ["SubmitVote", "SubmitForm"]
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state, action) => {
      localStorage.clear()
      state.hideSendOtpButton = false
      state.showVerifyOtpForm = false
      state.showLoginForm = true
      state.otpRequestSuccess = false
      state.otpRequestError = false
      state.otpValidateSuccess = false
      state.otpValidateError = false
      state.authToken = null
      state.role = null
    },
    backToLogin: (state) => {
      state.hideSendOtpButton = false
      state.showVerifyOtpForm = false
      state.showLoginForm = true
      state.otpRequestSuccess = false
      state.otpRequestError = false
      state.otpValidateSuccess = false
      state.otpValidateError = false
      state.role = null
      localStorage.clear()
    },
    setToken: (state, action) => {
      state.authToken = action.payload.authToken
      const tokenData = jwt_decode(action.payload.authToken);
      state.role = tokenData.Role;
      state.RoleID = tokenData.RoleID;
      state.userAccess = tokenData.userAccess
    }
  },
  extraReducers: {
    [requestOtp.fulfilled]: (state, action) => {
      const {message, data}  = action.payload
      if (message === 'OTP sent successfully') {
        if (data === 'OTP Sent') {
          state.hideSendOtpButton = true
          state.showVerifyOtpForm = true
          state.otpRequestSuccess = true
        } else {
          state.otpRequestError = true
        }
      } else {
        state.hideSendOtpButton = false
        state.showVerifyOtpForm = false
      }
    },
    // [requestOtp.pending]: (state, action) => {
    //   state.someValue += action.payload
    // },
    // [requestOtp.rejected]: (state, action) => {
    //   state.someValue += action.payload
    // },
    [validateOtp.fulfilled]: (state, action) => {
      console.log(action)
      const { data } = action.payload
      if (data !== 'Incorrect OTP') {
        localStorage.setItem('token', data.Token)
        state.authToken = data.Token
        state.ID = data.ID
        state.Name = data.Name
        state.otpValidateSuccess = true
        const tokenData = jwt_decode(data.Token);
        state.RoleID = tokenData.RoleID;
        state.role = tokenData.Role;
        state.userAccess = tokenData.userAccess
      } else {
        state.otpValidateError = true
        state.authToken = null
      }
    },
    // [validateOtp.pending]: (state, action) => {
    //   state.someValue += action.payload
    // },
    // [validateOtp.rejected]: (state, action) => {
    //   state.someValue += action.payload
    // }
  }
})

export const { logout, backToLogin, setToken } = authSlice.actions;


export default authSlice.reducer
